import { useEffect, useState } from "react";

/**
 * navigator.onLine を React state で expose する hook。 online / offline event を
 * subscribe して reactive に update する。
 *
 * mobile-pwa Phase 5 で OfflineIndicator UI から利用、 オフライン時の UX 通知に
 * 使う。 SSR safe (= typeof navigator チェック)。
 *
 * 注: navigator.onLine は brower 内部の判定で、 必ずしも真のネット接続を保証しない
 * (= LAN だけ繋がっていて WAN 不通でも online 判定が出ることがある)。 補強として
 * 実際の fetch 失敗時にも UI 表示できる二段構えが理想だが、 本 hook は最小実装。
 */
export function useOnline(): boolean {
  const [online, setOnline] = useState<boolean>(() =>
    typeof navigator !== "undefined" ? navigator.onLine : true,
  );

  useEffect(() => {
    const handleOnline = (): void => {
      setOnline(true);
    };
    const handleOffline = (): void => {
      setOnline(false);
    };
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return online;
}
